import { queryOptions, useQuery } from '@tanstack/react-query';

import { availableInstancesMockData } from './availableInstancesMockData';

const OMNI_AVAILABLE_INSTANCES_QUERY_KEY = 'omni-available-instances';

const getAvailableInstancesQueryOptions = () =>
  queryOptions({
    queryKey: [OMNI_AVAILABLE_INSTANCES_QUERY_KEY],
    queryFn: async () => {
      // Simulate network delay
      // TODO: Replace with real API call once the endpoint is available
      await new Promise((resolve) => setTimeout(resolve, 500));
      return availableInstancesMockData;
    },
  });

export const useGetAvailableInstancesQuery = () => {
  const {
    data: availableInstances,
    isLoading,
    error,
  } = useQuery(getAvailableInstancesQueryOptions());

  return {
    availableInstances,
    isLoading,
    error,
  };
};
